import { render, staticRenderFns } from "./EditServiceRetail.vue?vue&type=template&id=12b3424a&scoped=true"
import script from "./EditServiceRetail.vue?vue&type=script&lang=js"
export * from "./EditServiceRetail.vue?vue&type=script&lang=js"
import style0 from "./EditServiceRetail.vue?vue&type=style&index=0&id=12b3424a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3424a",
  null
  
)

export default component.exports